import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function Disclaimer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-486">
      <Navbar data-id="element-487" />
      <main className="pt-32 pb-24" data-id="element-488">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-489">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-490">
            Disclaimer
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-491">
            <p data-id="element-492">
              This Disclaimer forms part of, and must be read in conjunction
              with, the Website and Mobile Application Terms and Conditions.
              KittyPot Ltd reserves the right to update or amend this Disclaimer
              at any time.
            </p>

            <p data-id="element-493">
              The information provided on this website and within the KittyPot
              mobile application (together referred to as the "Services") is for
              general information purposes only. The Services are operated by
              https://kittypot.com ("Website") and the KittyPot mobile
              application ("App"), collectively referred to as "KittyPot Ltd",
              "we", "us", or "our".
            </p>

            <p data-id="element-494">
              By accessing or using our Services, you acknowledge and agree to
              the following:
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-495">
              1. Accuracy of Information
            </h2>
            <p data-id="element-496">
              While we strive to ensure the information provided through our
              Services is accurate and up to date, we do not guarantee its
              completeness, accuracy, reliability, or timeliness. Any reliance
              you place on such information is strictly at your own risk.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-497">
              2. Limitation of Liability
            </h2>
            <p data-id="element-498">
              To the fullest extent permitted by law, KittyPot Ltd shall not be
              liable for any loss or damage, whether direct, indirect,
              incidental, consequential, or otherwise, arising out of or in
              connection with your use of the Website or App. This includes, but
              is not limited to, financial loss, loss of data, or business
              interruption.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-499">
              3. Availability of Services
            </h2>
            <p data-id="element-500">
              The Website and App are provided on an "as is" and "as available"
              basis. We do not warrant that the Services will always be
              available, uninterrupted, secure, or error-free, or that any
              defects will be corrected.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-501">
              4. No Warranties
            </h2>
            <p data-id="element-502">
              KittyPot Ltd disclaims all warranties, express or implied,
              including but not limited to:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-503">
              <li data-id="element-504">
                Any implied warranties of merchantability or fitness for a
                particular purpose
              </li>
              <li data-id="element-505">
                Any warranties arising from course of dealing, usage, or trade
              </li>
              <li data-id="element-506">
                Any warranties that the Services will meet your requirements
              </li>
            </ul>
            <p data-id="element-507">
              You assume full responsibility for any risk associated with the
              use of our Services.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-508">
              5. Third-Party Services
            </h2>
            <p data-id="element-509">
              Our Services may rely on or link to third-party services,
              platforms, or providers. KittyPot Ltd makes no representations or
              warranties regarding these third parties and accepts no liability
              for their content, availability, or performance.
            </p>
            <p data-id="element-510">
              We will not be liable for any downtime or temporary unavailability
              caused by factors beyond our reasonable control, including
              technical failures or third-party outages.
            </p>

            <p className="mt-8" data-id="element-511">
              If you have any questions regarding this Disclaimer, please
              contact us via our website contact form.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-512" />
    </div>;
}